export default __webpack_public_path__ + "static/media/sales-by-client.3348b16e.svg";